import { render } from "./SimulacaoProducaoModal.vue?vue&type=template&id=11506c38&scoped=true&ts=true"
import script from "./SimulacaoProducaoModal.vue?vue&type=script&lang=ts"
export * from "./SimulacaoProducaoModal.vue?vue&type=script&lang=ts"

import "./SimulacaoProducaoModal.vue?vue&type=style&index=0&id=11506c38&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXApp\\NeoX.Frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11506c38"]])

export default __exports__